import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';

const getFullIOptionPrice = (product: TComplimentaryProductInfo) => {
  const salesPrice = product?.salesPriceValueInConsumerUnitValue ?? 0;
  const quantity = product.total.requiredQuantity;
  return salesPrice * quantity;
};

export const sortComplimentaryProductsByPrice = (
  products: TComplimentaryProductInfo[]
): TComplimentaryProductInfo[] =>
  [...products].sort((a, b) => getFullIOptionPrice(a) - getFullIOptionPrice(b));
